import { Autocomplete, Paper } from "@mui/material";
import { SyntheticEvent } from "react";
import { ExpandCollapseArrowIcon, TextFieldComponent } from "@gx1/gx-ui-common";
import classNames from "classnames";
import styles from "./autocomplete-v2.styles.module.scss";

type AutocompleteV2ComponentProps = {
  label: string;
  options: string[];
  onChange: (event: SyntheticEvent, value: string | null) => void;
  rootClassName?: string;
  value?: string | null;
};

/**
 * Autocomplete component requires null to ensure MUI behavior remains "controlled"
 * null fallback when undefined avoids uncontrolled to controlled component warning:
 *    MUI: A component is changing the uncontrolled value state of Autocomplete to be controlled.
 *    Elements should not switch from uncontrolled to controlled (or vice versa).
 */
const AutocompleteV2Component = ({
  label = "",
  options = [],
  onChange = () => {},
  rootClassName = "",
  value = null,
}: AutocompleteV2ComponentProps) => {
  return (
    <Autocomplete
      value={value}
      disableClearable={Boolean(value)}
      renderInput={(params) => <TextFieldComponent {...params} placeholder={label} />}
      options={options}
      onChange={onChange}
      blurOnSelect={true}
      popupIcon={<ExpandCollapseArrowIcon />}
      classes={{
        root: classNames(styles.root, rootClassName),
        popupIndicator: styles.popupIndicator,
        listbox: styles.listBox,
        option: styles.option,
      }}
      PaperComponent={({ children }) => (
        <Paper classes={{ root: classNames(styles.paperRoot, styles.paper) }}>
          {children}
        </Paper>
      )}
    />
  );
};

export default AutocompleteV2Component;
